import vClickOutside from "v-click-outside";
import moment from "moment";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	/**
	 * You can pass any <v-date-picker> prop to the <calendar> component.
	 *
	 * Here is a list of all available props:
	 * https://vcalendar.io/api/defaults.html
	 */
	inheritAttrs: false,

	directives: { clickOutside: vClickOutside.directive },

	props: {
		value: { required: true },

		availableBaselines: {
			type: Array,
			default: () => [],
		},

		// If provided, it doesn't open the date-picker, it just shows the date in an input
		readonly: Boolean,
	},

	data() {
		return {
			isCalendarVisible: false,
			formats: { title: "MMM YYYY" },
			date: {
				start: this.value.start,
				end: this.value.end,
			},
		};
	},

	computed: { ...userGetters(["activeOutlet"]) },

	methods: {
		hideCalendar,
		formatDate,
	},

	watch: {
		date(startDate) {
			const baseline = this.availableBaselines.find((baseline) => moment(startDate).isSame(baseline.start_date, "day"));
			if (baseline) {
				// we found a baseline for the selected date
				this.$emit("input", {
					start: baseline.start_date,
					end: baseline.end_date,
				});
			} else {
				/*
				 * the user probably deselected the date in the calendar,
				 * in that case we emit dates with null values
				 */
				this.$emit("input", {
					start: this.activeOutlet.baseline.start_date,
					end: this.activeOutlet.baseline.end_date,
				});
			}
		},
	},
};

function hideCalendar() {
	this.isCalendarVisible = false;
}

function formatDate(date) {
	moment.locale(localStorage.getItem("language") || "en");
	return `${moment(date.start).format("DD.MM.YYYY")} - ${moment(date.end).format("DD.MM.YYYY")}`;
}
